import Model from "@/models/Model";

export default class Like extends Model {
    resource() {
        return "likes";
    }

    baseURL() {
        return super.baseURL() + "/resourcecenter";
    }
}
